var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"letsgo-container",style:({'height': _vm.__layoutCenterHeightCalculate.value - 20 +'px'})},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }